import { CashRequestDetail } from "@/pages/requests/cash/schema/cash-requests.schema";
import { CheckRequestDetail } from "@/pages/requests/check/schema/check-requests.schema";
import { TransferRequestDetail } from "@/pages/requests/transfer/schema/transfer-requests.schema";
import { Text } from "@chakra-ui/react";

interface Props {
  request?:
    | CashRequestDetail
    | CheckRequestDetail
    | TransferRequestDetail
    | null;
}

export const RequestMovementNumber = ({ request }: Props) => {
  return (
    request?.idMovimientoBIND && (
      <Text
        className="account-title-label"
        data-testid="request-movement-number"
      >
        N° Movimiento: {request?.idMovimientoBIND}
      </Text>
    )
  );
};
